export default {
  items: [
    {
      title: 'directSecureTransfer.nav.title',
      id: 'DirectSecureTransfer',
      to: null,
      icon: 'send',
      sortOrder: 40,
      expanded: true,
      children: [
        {
          title: 'directSecureTransfer.nav.title',
          to: { name: 'DirectSecureTransferIndexPage' },
          icon: 'send',
          sortOrder: 10,
        },
      ],
    },
  ],
}
